import { useState, useMemo, useEffect } from "react"
import { Table } from "react-bootstrap"
import { fetchSelectors } from "./helpers"

const SummaryTable = ({
  data,
  setSelected,
  setSelectors,
  csvDownloadTracker,
  setCsvDownloadTracker,
}) => {
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  const sortData = useMemo(() => {
    let sortableItems = [...data]
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1
        }
        return 0
      })
    }
    return sortableItems
  }, [data, sortConfig])

  const requestSort = (key) => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  const formatNumber = (number) => {
    if (number === null || number === undefined || number === "") {
      return "0"
    }
    return number.toLocaleString()
  }

  const formatStringNumber = (value) => {
    if (!value) {
      return "0"
    }
    const number = parseFloat(value)
    return isNaN(number) ? value : number.toLocaleString()
  }

  const updateCustomer = (item) => {
    setSelected({ sales: [], customer: item[0], AM: [] })
    setCsvDownloadTracker(false)
    // Fetch selectors will update the selector elements
    // since the selectors object is passed as a prop to them
    fetchSelectors(setSelectors)
  }

  const exportToCsv = () => {
    const csvRows = [
      [
        "Customer",
        "Current",
        '="1-30"',
        "31-60",
        "61-90",
        "91+",
        "total",
        "order count",
        "Credit Extended",
        "Credit Available",
        "AM"
      ],
      ...sortData.map((item) => [
        `"${item[0]}"`,
        `"${item[1]}"`,
        `"${item[2]}"`,
        `"${item[3]}"`,
        `"${item[4]}"`,
        `"${item[5]}"`,
        `"${item[6]}"`,
        `"${item[7]}"`,
        `"${item[8]}"`,
        `"${item[9]}"`,
        `"${item[10]}"`,
      ]),
    ]
    const csvString = csvRows.map((row) => row.join(",")).join("\n")

    const blob = new Blob([csvString], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.setAttribute("hidden", "")
    a.setAttribute("href", url)
    a.setAttribute("download", "aging_summary.csv")
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    setCsvDownloadTracker(false)
  }

  useEffect(() => {
    if (csvDownloadTracker == true) {
      exportToCsv()
    }
  }, [csvDownloadTracker])

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th onClick={() => requestSort(0)}>Customer</th>
          <th onClick={() => requestSort(1)}>Current</th>
          <th onClick={() => requestSort(2)}>1-30</th>
          <th onClick={() => requestSort(3)}>31-60</th>
          <th onClick={() => requestSort(4)}>61-90</th>
          <th onClick={() => requestSort(5)}>91 and over</th>
          <th onClick={() => requestSort(6)}>Total</th>
          <th onClick={() => requestSort(7)}>Order Count</th>
          <th onClick={() => requestSort(8)}>Credit Extended</th>
          <th onClick={() => requestSort(9)}>Overdue Payment</th>
          <th onClick={() => requestSort(10)}>AM</th>
        </tr>
      </thead>
      <tbody>
        {sortData.map((item, index) => (
          <tr
            key={index}
            onClick={
              item[0] != "total" ? () => updateCustomer(item) : undefined
            }
          >
            <td>{item[0]}</td>
            <td>${formatNumber(item[1])}</td>
            <td>${formatNumber(item[2])}</td>
            <td>${formatNumber(item[3])}</td>
            <td>${formatNumber(item[4])}</td>
            <td>${formatNumber(item[5])}</td>
            <td>${formatNumber(item[6])}</td>
            <td>{item[7]}</td>
            <td>${formatStringNumber(item[8])}</td>
            <td>${formatNumber(item[9])}</td>
            <td>{item[10]}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default SummaryTable
